export const columns = [
  {
    Header: "Descrição",
    getValue: (data) => data?.descricao || "-",
    field: "descricao",
  },
  {
    Header: "Código",
    getValue: (data) => data?.codigo || "-",
  },
];
